(() => {
  const FILTER_SELECTOR = '.cz-unified-filter';
  const GROUP_LIMIT = 5;
  const mobileOpenGroups = new Set();

  function filterGroupLabel(group) {
    const heading = group?.querySelector('toggle-target.filter-group__heading .filter-group__heading__text');
    return heading?.textContent.replace(/\s+/g, ' ').trim() || '';
  }

  function isMobileFilterDrawer() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  document.addEventListener('click', (event) => {
    if (!isMobileFilterDrawer()) return;
    const heading = event.target.closest('.cz-unified-filter toggle-target.filter-group__heading');
    if (!heading) return;
    const group = heading.closest('.filter-group');
    const target = document.querySelector(heading.dataset.toggleTarget);
    const label = filterGroupLabel(group);
    if (!target || !label) return;
    if (target.classList.contains('toggle-target--hidden')) mobileOpenGroups.add(label);
    else mobileOpenGroups.delete(label);
  }, true);

  function collapseFilterGroups(root) {
    root.querySelectorAll(`${FILTER_SELECTOR} .filter-group`).forEach((group) => {
      if (group.classList.contains('filter-group--applied')) return;
      if (group.dataset.czInitialCollapseReady === 'true') return;
      group.dataset.czInitialCollapseReady = 'true';
      const items = group.querySelector('.filter-group__items.toggle-target');
      const heading = group.querySelector('toggle-target.filter-group__heading');
      if (!items || !heading) return;
      if (isMobileFilterDrawer() && mobileOpenGroups.has(filterGroupLabel(group))) {
        items.classList.remove('toggle-target--hidden', 'toggle-target--in-transition', 'toggle-target--hiding');
        heading.classList.remove('toggle-target-toggler--is-hidden');
        items.style.height = '';
        items.style.opacity = '';
        items.style.display = '';
        return;
      }
      if (group.querySelector('.filter-group__item--active, input:checked')) return;
      items.classList.add('toggle-target--hidden');
      heading.classList.add('toggle-target-toggler--is-hidden');
    });
  }

  function addSeeMore(root) {
    root.querySelectorAll(`${FILTER_SELECTOR} .filter-group .toggle-target-container`).forEach((container) => {
      const options = [...container.children].filter((item) => item.classList.contains('filter-group__item'));
      const signature = options.map((option) => {
        const input = option.querySelector('input');
        return input
          ? `${input.name || ''}:${input.value || ''}`
          : option.textContent.replace(/\s+/g, ' ').trim();
      }).join('|');

      if (container.dataset.czSeeMoreSignature === signature) return;
      container.dataset.czSeeMoreSignature = signature;
      container.dataset.czSeeMoreReady = 'true';
      container.classList.remove('cz-filter-options-expanded');
      container.querySelectorAll(':scope > .cz-filter-see-more').forEach((button) => button.remove());
      options.forEach((option) => {
        option.classList.remove('cz-filter-extra');
        option.style.removeProperty('display');
      });

      if (options.length <= GROUP_LIMIT) return;

      const extraOptions = options.slice(GROUP_LIMIT);
      extraOptions.forEach((option) => option.classList.add('cz-filter-extra'));

      function setExtraOptionsVisible(expanded) {
        extraOptions.forEach((option) => {
          if (expanded) option.style.removeProperty('display');
          else option.style.setProperty('display', 'none', 'important');
        });
      }

      const hasActiveExtra = extraOptions.some((option) =>
        option.classList.contains('filter-group__item--active') || option.querySelector('input:checked')
      );
      if (hasActiveExtra) container.classList.add('cz-filter-options-expanded');
      setExtraOptionsVisible(hasActiveExtra);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cz-filter-see-more';
      button.textContent = hasActiveExtra ? 'See less' : `See more (${extraOptions.length})`;
      button.setAttribute('aria-expanded', hasActiveExtra ? 'true' : 'false');
      button.addEventListener('click', () => {
        const expanded = container.classList.toggle('cz-filter-options-expanded');
        setExtraOptionsVisible(expanded);
        button.textContent = expanded ? 'See less' : `See more (${extraOptions.length})`;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      container.appendChild(button);
    });
  }

  function setDefaultClosed(root) {
    root.querySelectorAll('filter-container:has(.cz-unified-filter)').forEach((container) => {
      if (container.dataset.czDefaultStateReady === 'true') return;
      container.dataset.czDefaultStateReady = 'true';
      container.classList.remove('filter-container--show-filters-desktop');
      const toolbar = container.previousElementSibling;
      toolbar?.querySelector('[data-toggle-filters]')?.classList.remove('toggle-btn--revealed-desktop');
    });
  }

  function initialize(root = document) {
    setDefaultClosed(root);
    collapseFilterGroups(root);
    addSeeMore(root);
  }

  function boot() {
    initialize(document);
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;
      initialize(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();


/* Free Swatches: keep filter-result scrolling stable across AJAX and navigation. */
(() => {
  if (window.__czStableFilterResultScroll) return;
  window.__czStableFilterResultScroll = true;

  const STORAGE_KEY = 'cz-filter-result-scroll-requested-at';
  const ACTION_SELECTOR = [
    '.free-swatches-quick__option',
    '.free-swatches-client-option',
    '[data-fs-product-type-option]',
    '[data-fs-native-option]',
    '[data-fs-clear-native-group]',
    '[data-fs-clear-client]',
    '[data-fs-client-type-option]',
    '[data-fs-best-sellers]',
    '.filter-group__applied-item',
    '.filter-group__checkbox'
  ].join(', ');

  let activeUntil = 0;
  let mutationTimer = 0;
  let mobileScrollPending = false;
  const attemptTimers = new Set();

  function mobileDrawerOpen() {
    return window.matchMedia('(max-width: 767px)').matches &&
      Boolean(document.querySelector('.filter-container--show-filters-mobile'));
  }

  function resultsTarget() {
    return document.querySelector('.emily-box .filters-adjacent') ||
      document.querySelector('.emily-box .collection-listing') ||
      document.querySelector('.emily-box [data-result-count]');
  }

  function toolbarOffset() {
    const toolbar = document.querySelector('.emily-box .utility-bar.free-swatches-toolbar');
    if (!toolbar) return 16;
    const styles = window.getComputedStyle(toolbar);
    const top = parseFloat(styles.top) || 0;
    return Math.max(16, top + toolbar.offsetHeight + 12);
  }

  function jumpToResults(force = false) {
    if (!force && Date.now() > activeUntil) return;
    if (mobileDrawerOpen()) {
      mobileScrollPending = true;
      return;
    }
    const target = resultsTarget();
    if (!target) return;
    mobileScrollPending = false;
    const top = target.getBoundingClientRect().top + window.scrollY - toolbarOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-toggle-filters]')) return;
    window.setTimeout(() => {
      if (!mobileScrollPending || mobileDrawerOpen()) return;
      window.requestAnimationFrame(() => jumpToResults(true));
    }, 0);
  }, true);

  function scheduleAttempts(delays) {
    delays.forEach((delay) => {
      const timer = window.setTimeout(() => {
        attemptTimers.delete(timer);
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(jumpToResults);
        });
      }, delay);
      attemptTimers.add(timer);
    });
  }

  function rememberRequest() {
    activeUntil = Date.now() + 5000;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (error) {}
    scheduleAttempts([120, 420, 850, 1400, 2200]);
  }

  function resumeRequest() {
    let requestedAt = 0;
    try {
      requestedAt = Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
    } catch (error) {}
    if (!requestedAt || Date.now() - requestedAt > 8000) return;
    activeUntil = Date.now() + 4200;
    scheduleAttempts([80, 320, 700, 1200, 2000, 3200]);
    window.setTimeout(() => {
      try {
        if (Number(sessionStorage.getItem(STORAGE_KEY)) === requestedAt) {
          sessionStorage.removeItem(STORAGE_KEY);
        }
      } catch (error) {}
    }, 4300);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest(ACTION_SELECTOR)) rememberRequest();
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('.filter-group__checkbox')) rememberRequest();
  }, true);

  const observer = new MutationObserver((mutations) => {
    if (Date.now() > activeUntil) return;
    const resultsChanged = mutations.some((mutation) => {
      const node = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      return node && node.closest && node.closest('.emily-box');
    });
    if (!resultsChanged) return;
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(jumpToResults, 100);
  });

  function bootStableScroll() {
    observer.observe(document.body, { childList: true, subtree: true });
    resumeRequest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStableScroll, { once: true });
  } else {
    bootStableScroll();
  }
})();


/* Free Swatches: turn empty results into a helpful contact path. */
(() => {
  if (window.__czEmptySwatchHelp) return;
  window.__czEmptySwatchHelp = true;

  function enhanceEmptyStates(root = document) {
    root.querySelectorAll('[data-free-swatches-search-empty]').forEach((emptyState) => {
      if (emptyState.dataset.czEmptyHelpReady === 'true') return;
      emptyState.dataset.czEmptyHelpReady = 'true';

      const heading = emptyState.querySelector('h3');
      const copy = emptyState.querySelector('p');
      const clearButton = emptyState.querySelector('[data-free-swatches-search-clear]');

      if (heading) heading.textContent = 'Can’t find the right swatch?';
      if (copy) {
        copy.textContent = 'Try removing a filter, or send us the colors, room photos, or swatch names you like. We’ll help you find the closest options.';
      }

      let actions = emptyState.querySelector('.cz-empty-swatches__actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'cz-empty-swatches__actions';
        if (clearButton) {
          clearButton.parentNode.insertBefore(actions, clearButton);
          actions.appendChild(clearButton);
        } else {
          emptyState.appendChild(actions);
        }
      }

      if (!actions.querySelector('.cz-empty-swatches__contact')) {
        const contact = document.createElement('a');
        contact.className = 'cz-empty-swatches__contact';
        contact.href = '/pages/contact-us';
        contact.textContent = 'Message Us';
        contact.setAttribute('role', 'button');
        contact.setAttribute('aria-haspopup', 'dialog');
        contact.setAttribute('aria-controls', 'cz-contact-dialog');
        contact.addEventListener('click', (event) => {
          const launcher = document.querySelector('[data-cz-contact-open]');
          const dialog = document.getElementById('cz-contact-dialog');
          if (!launcher || !dialog) return;

          // The native widget remembers this focus for its existing close action.
          contact.focus({ preventScroll: true });
          event.preventDefault();
          launcher.click();
          // Keep a real contact route if the widget has not initialized.
          if (dialog.hidden) window.location.assign(contact.href);
        });
        contact.addEventListener('keydown', (event) => {
          if (event.key !== ' ') return;
          event.preventDefault();
          if (!event.repeat) contact.click();
        });
        actions.appendChild(contact);
      }
    });
  }

  function bootEmptyHelp() {
    enhanceEmptyStates();
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
      enhanceEmptyStates();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootEmptyHelp, { once: true });
  } else {
    bootEmptyHelp();
  }
})();
